import * as React from 'react';
import Moment from 'react-moment';
import { KonkurrencestatusEnum } from '../../models/enums/KonkurrencestatusEnum';

class TableFormatters {
    static dateFormatter(cell: any, row: any) {
        return (
            <Moment format='DD.MM.YY'>{cell}</Moment>
        );
    }

    static dateDaysFormatter(cell: any, row: any) {
        return (
            <Moment locale='da' fromNow={true} utc={false}>{cell}</Moment>
        );
    }

    static getStatusText(status: KonkurrencestatusEnum) {
        switch (status) {
            case KonkurrencestatusEnum.IkkePubliceret:
                return 'Ikke publiceret';

            default:
                return KonkurrencestatusEnum[status];
        }
    }

    static getShortDate(date: Date): string {
        var newDate = new Date(date);
        let day = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();

        return day + '.' + month + '.' + year;
    }

    static tilmeldingStatusFormatter(cell: any, row: any) {
        if (row.paaVenteliste) {
            return 'På venteliste';
        } else {
            return 'Tilmeldt';
        }
    }

    static booleanFormatter(bool: boolean) {
        if (bool === true) {
            return 'Ja';
        } else {
            return 'Nej';
        }
    }

}

export default TableFormatters;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/table/TableFormatters.tsx